export const iconFontAwesomeHandsHandScissors = (
	<i className="fa-solid fa-hand-scissors"></i>
);
